export default __webpack_public_path__ + "static/media/disable.511e1bd1.svg";